"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IndexRoute = _interopRequireDefault(require("react-router/lib/IndexRoute"));
var _Route = _interopRequireDefault(require("react-router/lib/Route"));
var _browser = require("angieslist-app-platform/lib/browser");
var _myAccount = _interopRequireDefault(require("../containers/myAccount"));
var _contactPreferences = _interopRequireDefault(require("../containers/contactPreferences"));
var _default = exports["default"] = function _default(App) {
  return function createRoutes(getState, dispatch) {
    return /*#__PURE__*/_react["default"].createElement(_Route["default"], {
      component: App,
      path: "/app/account"
    }, /*#__PURE__*/_react["default"].createElement(_IndexRoute["default"], {
      component: function component() {
        return /*#__PURE__*/_react["default"].createElement(_myAccount["default"], {
          showContactPrefModal: false
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_Route["default"], {
      path: "preferences"
    }, /*#__PURE__*/_react["default"].createElement(_IndexRoute["default"], {
      component: function component() {
        return /*#__PURE__*/_react["default"].createElement(_myAccount["default"], {
          showContactPrefModal: true
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_Route["default"], {
      component: function component() {
        return /*#__PURE__*/_react["default"].createElement(_contactPreferences["default"], null);
      },
      path: "unsubscribe"
    })), /*#__PURE__*/_react["default"].createElement(_Route["default"], {
      component: _browser.OfficeNotFoundView,
      path: "*"
    }));
  };
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/office/browser/routes/routes.js
// module id = 4035
// module chunks = 9